// extracted by mini-css-extract-plugin
export default {"wrapper":"EditCv_wrapper__JgvHh"};